/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { memo, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { timestampToDateTime } from "../Helpers/common";
import { UrlPreview, previewLinkIcon } from "../Helpers/chatCommon";
import AttachmentsFiles from "./attachmentFile";
import { PinFillIcon } from "../../assets/icons/svg";

const ChatBoardThreadOutgoing = ({ value, userInfo, senderID }) => {
  let IsNewLineExist = null;

  if (
    value.message !== "c2-attach-files" &&
    value.message !== "c2-attach-recording-file"
  ) {
    IsNewLineExist = /\r|\n/.exec(value.message);
  }

  const { call, chat, authUserDetail } = useSelector((state) => state);
  const { allAttendeeList } = call || {};
  const { authSessionUser } = authUserDetail || {};
  const { deletedMessageIds, deleteChatData } = chat || {};

  useEffect(() => {
    if (deleteChatData?.messageID) {
      let deletedID = document.getElementById(deleteChatData.messageID);
      if (deletedID) {
        deletedID.classList.add("chat_row_hide");
      }
    }
  }, [deleteChatData]);

  const showMessage = (value) => {
    if (
      value.attachments !== undefined &&
      value.attachments.length > 0 &&
      (value.message === "c2-attach-files" ||
        value.message === "c2-attach-recording-file")
    ) {
      if (
        (value.message === "c2-attach-recording-file" &&
          value.senderID === authSessionUser?.user_id) ||
        value.message === "c2-attach-files"
      ) {
        return (
          <div className="d-flex file_send_info gap-10 flex-wrap">
            {value?.attachment_caption ? (
              <div className="file_send_info_inner">
                <div className="d-flex flex-wrap gap-y-10">
                  {value.attachments.map((attachmentItem, attachmentIndex) => {
                    return (
                      <div className="w-100" key={attachmentIndex}>
                        {/* eslint-disable-next-line indent */}
                        {/* eslint-disable-next-line indent */}
                        <AttachmentsFiles
                          attachmentItem={attachmentItem}
                          messageDetail={value}
                        />
                      </div>
                    );
                  })}
                </div>

                <div>
                  {value?.attachment_caption && (
                    <span>
                      <p
                        className="break-words"
                        dangerouslySetInnerHTML={{
                          __html: value?.attachment_caption,
                        }}
                      />
                    </span>
                  )}
                </div>
              </div>
            ) : (
              value.attachments.map((attachmentItem, attachmentIndex) => {
                return (
                  <div className="w-100" key={attachmentIndex}>
                    {/* eslint-disable-next-line indent */}
                    {/* eslint-disable-next-line indent */}
                    <AttachmentsFiles
                      attachmentItem={attachmentItem}
                      messageDetail={value}
                    />
                  </div>
                );
              })
            )}
          </div>
        );
      } else {
        return false;
      }
    } else {
      if (IsNewLineExist !== null) {
        const newMessage =
          value.preview &&
          Array.isArray(value.preview) &&
          value.preview.length > 0
            ? value.message_array.join(" ")
            : value.message.replace(/ /g, "&nbsp;");

        return (
          <>
            {newMessage?.split("\n").map((str, index) => (
              <>
                <div
                  key={index}
                  className="d-flex file_send_info gap-10 flex-wrap share-link"
                >
                  <p
                    className="break-words"
                    dangerouslySetInnerHTML={{ __html: str }}
                  />
                  {previewLinkIcon(value)}
                </div>
              </>
            ))}
            {value?.preview ? UrlPreview(value?.preview) : null}
          </>
        );
      } else {
        return (
          <>
            <div className="d-flex justify-content-between gap-10 align-items-start">
              <div className="d-flex file_send_info gap-10 flex-wrap">
                <p
                  className="break-words"
                  dangerouslySetInnerHTML={{
                    __html:
                      value.preview &&
                      Array.isArray(value.preview) &&
                      value.preview.length > 0
                        ? value.message_array.join(" ")
                        : value.message,
                  }}
                />
                {previewLinkIcon(value)}
              </div>

              <div className="d-flex align-items-center justify-content-end text-orange cursor-pointer no-whitespace">
                <span className="chat_count d-flex align-items-center justify-content-center align-self-center mr-2">
                  {value?.count || 0}
                </span>
              </div>
            </div>
            {value?.preview ? UrlPreview(value?.preview) : null}
          </>
        );
      }
    }
  };

  const isUserOnline = useMemo(() => {
    return allAttendeeList.find((item) => item.user_id === value.senderID)
      ?.online
      ? true
      : false;
  }, [allAttendeeList, value.senderID]);

  let pinned_by_username = "";
  if (value?.pinned_by) {
    allAttendeeList.some((v) => {
      if (senderID === value.pinned_by) {
        pinned_by_username = "you";
      } else if (v.user_id === value.pinned_by) {
        pinned_by_username = v.name;
      }
    });
  }

  return (
    <>
      <div
        className={`chat_row ${
          deletedMessageIds?.includes(value?.id) ? "chat_row_hide" : ""
        } ${value?.pinned && "highlight"}`}
        id={value.id}
        key={value.id}
      >
        <div className="w-100 d-flex flex-column max-w-100">
          {value?.pinned && (
            <div className="d-flex align-items-center">
              <div className="pinned-icon">
                <PinFillIcon
                  className="bi bi-pin-angle-fill flip-icon text-orange-light"
                  width={14}
                  height={14}
                />
              </div>
              <span>
                &nbsp;Pinned by&nbsp;
                {pinned_by_username === "you" ? (
                  pinned_by_username
                ) : (
                  <a>
                    <strong>{` ${pinned_by_username}`}</strong>
                  </a>
                )}
              </span>
            </div>
          )}
          <div className="d-flex">
            <div className="avatar ">
              <img
                className="h-100"
                src={`${
                  authSessionUser.user_profile_image ? (
                    authSessionUser.user_profile_image
                  ) : (
                    <svg viewBox="3 2 18 19">
                      <path
                        fill="#425b76"
                        d="M7.5 6.5C7.5 8.981 9.519 11 12 11s4.5-2.019 4.5-4.5S14.481 2 12 2 7.5 4.019 7.5 6.5zM20 21h1v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h17z"
                      ></path>
                    </svg>
                  )
                }`}
              ></img>
              <span className={`status ${isUserOnline && "online"}`}></span>
            </div>

            <div
              className={`bubble inner-bubble ${
                value.isReply === true && "reply"
              }`}
            >
              {value.isReply === true && (
                <h3 className="Name-messenger">{userInfo.name} </h3>
              )}
              <div className={`${value.isReply === true && "reply-inner"}`}>
                {value.isReply === true ? (
                  <h3 className="Name-messenger flex-column align-items-start">
                    <div>
                      <p
                        className="break-words text-grey"
                        dangerouslySetInnerHTML={{ __html: value.earlyMessage }}
                      />

                      <div className="time ml-0 mt-1">
                        {allAttendeeList?.find(
                          (findItem) =>
                            findItem.user_id === value.earlyMsgSenderID,
                        )?.name ?? ""}
                        , {timestampToDateTime(value.earlyMsgTimestamp)}
                      </div>
                    </div>
                  </h3>
                ) : (
                  <h3 className="Name-messenger">
                    {userInfo.name}{" "}
                    <div className="time">
                      {timestampToDateTime(value.timestamp)}
                    </div>
                  </h3>
                )}
              </div>
              {showMessage(value)}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(ChatBoardThreadOutgoing);
